import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { services } from "../../data/mock";
import { useLanguage } from "../../i18n/LanguageContext";

export default function Services() {
  const { t } = useLanguage();

  return (
    <section id="services" className="section-bg relative py-24 lg:py-32 overflow-hidden">
      <div className="orb bg-blue-600/20 w-[500px] h-[500px] top-[10%] left-[-150px]" />
      <div className="orb bg-cyan-500/15 w-[500px] h-[500px] bottom-[5%] right-[-150px]" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="kicker">{t("services.kicker")}</span>
          <h2 className="mt-5 font-display text-4xl lg:text-5xl font-bold text-white leading-tight">
            {t("services.title1")} <span className="grad-text">{t("services.titleAccent")}</span>
          </h2>
          <p className="mt-4 text-slate-300/90 text-lg">{t("services.description")}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => {
            const Icon = s.icon;
            const localized = t(`services.items.${s.slug}`) || {};
            const title = localized.title || s.title;
            const description = localized.description || s.description;
            const features = localized.features || s.features;
            return (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                className="group glass lift rounded-2xl overflow-hidden flex flex-col"
              >
                <div className="relative h-44 overflow-hidden">
                  <img src={s.image} alt={title} className="w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#050818] via-[#050818]/60 to-transparent" />
                  <div className={`absolute top-4 left-4 w-11 h-11 rounded-xl bg-gradient-to-br ${s.accent} shadow-lg shadow-cyan-500/20 flex items-center justify-center`}>
                    <Icon className="w-5 h-5 text-white" strokeWidth={2.2} />
                  </div>
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <h3 className="font-display text-xl font-semibold text-white group-hover:text-cyan-300 transition">
                    {title}
                  </h3>
                  <p className="mt-3 text-sm text-slate-400 leading-relaxed line-clamp-4">{description}</p>
                  <ul className="mt-5 space-y-2 mb-6">
                    {features.map((f) => (
                      <li key={f} className="flex items-center gap-2 text-sm text-slate-300">
                        <span className="w-4 h-4 rounded-full bg-cyan-500/15 border border-cyan-400/30 flex items-center justify-center">
                          <Check className="w-2.5 h-2.5 text-cyan-300" strokeWidth={3} />
                        </span>
                        {f}
                      </li>
                    ))}
                  </ul>
                  <div className="mt-auto flex items-center gap-1.5 text-sm font-semibold text-cyan-300 group-hover:text-cyan-200">
                    {t("services.learnMore")} <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition" />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
